import { useQuery } from '@tanstack/react-query';

type UserCredentials = {
  has_password: boolean;
};

export const useUserCredentials = () => {
  const { data, isLoading, isError } = useQuery<UserCredentials>({
    queryKey: ['me', 'credentials'],
    retry: false,
  });

  return {
    hasPasswordSet: data?.has_password ?? false,
    isLoading,
    isError,
  };
};
